import { DatePicker, FilterModal, SelectSearch } from 'components';
import { useFormik } from 'formik';
import { useContext } from 'react';
import { DateConvert } from 'utilities';
import { DropdownTransferBahanProduksiContext } from '../Context';

export const ModalFilterTransferBahanProduksi = ({
  show,
  setShow,
  filter,
  setFilter,
}) => {
  const { dropdown, dropdownBahan, dropdownGudang, dropdownKaryawan } =
    useContext(DropdownTransferBahanProduksiContext);
  const defaultDrodown = { value: null, label: 'Semua' };
  const defaultDrodownItemJO = { value: null, label: 'Semua', nama_item: null };
  const initialValues = {
    tgl_job_order_start: filter?.tgl_job_order_start,
    tgl_job_order_end: filter?.tgl_job_order_end,
    tgl_transfer_produksi_bahan_start:
      filter?.tgl_transfer_produksi_bahan_start,
    tgl_transfer_produksi_bahan_end: filter?.tgl_transfer_produksi_bahan_end,
    item_job_order: filter?.item_job_order,
    id_item_buaso: filter?.id_item_buaso,
    id_gudang_asal: filter?.id_gudang_asal,
    id_karyawan: filter?.id_karyawan,
  };

  const onSubmit = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    if (checkActive) {
      setFilter((prev) => ({
        ...prev,
        ...values,
        active: true,
        page: '1',
      }));

      setShow(false);
      return;
    }

    setFilter((prev) => ({ ...prev, ...values, filter: false }));
    setShow(false);
  };

  const onResetButtonClick = () => {
    setFilter((prev) => ({
      ...prev,
      page: '1',
      active: false,
      tgl_job_order_start: undefined,
      tgl_job_order_end: undefined,
      tgl_transfer_produksi_bahan_start: undefined,
      tgl_transfer_produksi_bahan_end: undefined,
      item_job_order: undefined,
      id_item_buaso: undefined,
      id_gudang_asal: undefined,
      id_karyawan: undefined,
    }));

    setShow(false);
  };

  const formik = useFormik({ initialValues, onSubmit });

  const { values, setFieldValue, handleSubmit } = formik;

  return (
    <FilterModal
      show={show}
      setShow={setShow}
      onResetButtonClick={() => onResetButtonClick()}
      onFilterButtonClick={handleSubmit}
    >
      <DatePicker
        selectsRange
        monthsShown={2}
        label="Tgl. Job Order"
        placeholderText="Pilih Tgl. Job Order"
        startDate={
          values.tgl_job_order_start ? new Date(values.tgl_job_order_start) : ''
        }
        endDate={
          values.tgl_job_order_end ? new Date(values.tgl_job_order_end) : ''
        }
        onChange={(dates) => {
          const [start, end] = dates;
          const startDate = start ? DateConvert(start).default : null;
          const endDate = end ? DateConvert(end).default : null;

          setFieldValue('tgl_job_order_start', startDate);
          setFieldValue('tgl_job_order_end', endDate);
        }}
      />

      <SelectSearch
        label="Item Job Order"
        placeholder="Pilih Item Job Order"
        loading={dropdownBahan?.isLoading}
        option={[defaultDrodownItemJO].concat(dropdownBahan?.data)}
        defaultValue={
          values.item_job_order
            ? dropdownBahan?.data?.find(
                (v) => values.item_job_order === v.nama_item
              )
            : defaultDrodown
        }
        onChange={({ nama_item }) => setFieldValue('item_job_order', nama_item)}
      />

      <DatePicker
        selectsRange
        monthsShown={2}
        label="Tgl. Transfer Bahan Produksi"
        placeholderText="Pilih Tgl. Transfer Bahan Produksi"
        startDate={
          values.tgl_transfer_produksi_bahan_start
            ? new Date(values.tgl_transfer_produksi_bahan_start)
            : ''
        }
        endDate={
          values.tgl_transfer_produksi_bahan_end
            ? new Date(values.tgl_transfer_produksi_bahan_end)
            : ''
        }
        onChange={(dates) => {
          const [start, end] = dates;
          const startDate = start ? DateConvert(start).default : null;
          const endDate = end ? DateConvert(end).default : null;

          setFieldValue('tgl_transfer_produksi_bahan_start', startDate);
          setFieldValue('tgl_transfer_produksi_bahan_end', endDate);
        }}
      />

      <SelectSearch
        label="Item Bahan"
        placeholder="Pilih Item Bahan"
        loading={dropdownBahan.isLoading}
        option={[defaultDrodown].concat(dropdownBahan?.data)}
        defaultValue={
          values.id_item_buaso
            ? dropdownBahan?.data?.find((v) => values.id_item_buaso === v.value)
            : defaultDrodown
        }
        onChange={({ value }) => setFieldValue('id_item_buaso', value)}
      />

      <SelectSearch
        label="Gudang Asal"
        placeholder="Pilih Gudang"
        loading={dropdownGudang.isLoading}
        option={[defaultDrodown].concat(dropdownGudang?.data)}
        defaultValue={
          values.id_gudang_asal
            ? dropdownGudang?.data?.find(
                (v) => values.id_gudang_asal === v.value
              )
            : defaultDrodown
        }
        onChange={({ value }) => setFieldValue('id_gudang_asal', value)}
      />

      <SelectSearch
        label="Diserahkan Kepada"
        placeholder="Pilih Karyawan"
        loading={dropdownKaryawan.isLoading}
        option={[defaultDrodown].concat(dropdownKaryawan?.data)}
        defaultValue={
          values.id_karyawan
            ? dropdownKaryawan?.data?.find(
                (v) => values.id_karyawan === v.value
              )
            : defaultDrodown
        }
        onChange={({ value }) => setFieldValue('id_karyawan', value)}
      />
    </FilterModal>
  );
};
